import { render, staticRenderFns } from "./modalPesoVolumetrico.vue?vue&type=template&id=4e4d4d71"
import script from "./modalPesoVolumetrico.vue?vue&type=script&lang=js"
export * from "./modalPesoVolumetrico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports